import { QueryHookOptions } from '@apollo/client';
import { J1QLResultData, QueryV1Input } from '../../types/J1QL';
import { QueryV1 } from '../graphql/queries/J1';
import useJ1QLWithCursorPagination, {
  UseJ1QLWithCursorPaginationResult,
} from './graphql/useJ1QLWithCursorPagination';
import mergeJ1QLDataResponses from './utils/mergeJ1QLDataResponses';

export interface J1QLOptions extends Omit<QueryV1Input, 'query'> {
  variables?: Record<string, string | number | boolean>;
  skip?: boolean;
  fetchPolicy?:
    | 'cache-first'
    | 'network-only'
    | 'cache-only'
    | 'no-cache'
    | 'standby'
    | 'cache-and-network';
  errorPolicy?: QueryHookOptions['errorPolicy'];
}

export default function useJ1QL<T extends J1QLResultData>(
  j1Query: string,
  options?: J1QLOptions
): UseJ1QLWithCursorPaginationResult<T> {
  const j1QLResult = useJ1QLWithCursorPagination<T>({
    query: QueryV1,
    dataPath: 'queryV1',
    cursorPath: 'queryV1.cursor',
    mergeDataResponses: mergeJ1QLDataResponses,
    variables: {
      query: j1Query,
      variables: options?.variables,
      flags: options?.flags,
      includeDeleted: options?.includeDeleted,
      cursor: options?.cursor,
    },
    // I cannot stress enough how important this combination of fetch policies is.
    // Apollo Client v3 changed some of the fetch policy behavior, so on a fetchMore
    // a refetch is triggered with the original variables.  The nextFetchPolicy here
    // makes sure we don't make a network call on that erroneous refetch- henry
    fetchPolicy: options?.fetchPolicy || 'no-cache',
    nextFetchPolicy: 'cache-first',
    skip: options?.skip,
    errorPolicy: options?.errorPolicy,
  });

  return {
    ...j1QLResult,
  };
}
